var _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimelimitRedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 32,
    viewBox: "0 0 55 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6271 0C29.9934 0 23 6.99336 23 15.6271C23 24.2609 29.9934 31.2542 38.6271 31.2542C47.2609 31.2542 54.2542 24.2609 54.2542 15.6271C54.2542 6.99336 47.2609 0 38.6271 0ZM45.1024 17.3107H38.6271C37.9365 17.3107 37.3752 16.7495 37.3752 16.0588V7.94308C37.3752 7.25239 37.9365 6.69119 38.6271 6.69119C39.3178 6.69119 39.879 7.25239 39.879 7.94308V14.8501H45.1024C45.7931 14.8501 46.3543 15.4113 46.3543 16.102C46.3543 16.7495 45.7931 17.3107 45.1024 17.3107Z",
    fill: "#DD6369"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 21.4346,
    width: 19,
    height: 3,
    rx: 1.5,
    transform: "rotate(-45 0 21.4346)",
    fill: "#DD6369"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.12134,
    y: 8,
    width: 19,
    height: 3,
    rx: 1.5,
    transform: "rotate(45 2.12134 8)",
    fill: "#DD6369"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelimitRedIcon);
export default __webpack_public_path__ + "static/media/timelimit_red_icon.8aa0ced8e700647c58b79350f7cd36a3.svg";
export { ForwardRef as ReactComponent };